var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVarifyCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#70d09d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.563,14.563a14,14,0,1,1-14-14A14,14,0,0,1,28.563,14.563ZM12.943,21.975,23.33,11.588a.9.9,0,0,0,0-1.277L22.053,9.034a.9.9,0,0,0-1.277,0L12.3,17.5,8.349,13.55a.9.9,0,0,0-1.277,0L5.795,14.827a.9.9,0,0,0,0,1.277l5.871,5.871a.9.9,0,0,0,1.277,0Z",
    transform: "translate(-0.563 -0.563)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarifyCheckIcon);
export default __webpack_public_path__ + "static/media/varify-check-icon.7f10ad37ba7f3315c4b7dfbc0527127d.svg";
export { ForwardRef as ReactComponent };